import React, { useState, useEffect } from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const RoleLoader = () => {
  const [statusIndex, setStatusIndex] = useState(0);

  const statuses = [
    "INTERROGATING ACCESS CONTROL LIST",
    "DECRYPTING PERMISSION SCHEMAS",
    "VALIDATING HIERARCHY LEVELS",
    "REBUILDING SECURITY TOKEN",
    "ESTABLISHING ROLE-BASED SCOPE",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setStatusIndex((prev) => (prev + 1) % statuses.length);
    }, 3200);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        height: '82vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        position: 'relative',
      }}
    >
      {/* ===== LOTTIE ANIMATION ===== */}
      <Box sx={{ width: 300, height: 300, mb: 3 }}>
        <DotLottieReact
          src="https://lottie.host/318bad24-8268-4527-9ded-0fbb69084e93/5M89WyioRT.lottie"
          loop
          autoplay
        />
      </Box>

      {/* ===== TEXT ===== */}
      <Box sx={{ textAlign: "center", width: "100%", maxWidth: 300 }}>
        <Typography
          sx={{
            fontSize: 14,
            fontWeight: 900,
            letterSpacing: "3px",
            mb: 2,
            textTransform: "uppercase",
          }}
        >
          Access Engine
        </Typography>

        <LinearProgress
          sx={{
            height: 2,
            borderRadius: 1,
            bgcolor: "#E2E8F0",
            "& .MuiLinearProgress-bar": {
              bgcolor: "primary.main",
            },
            mb: 2,
          }}
        />

        <Typography
          sx={{
            fontSize: 10,
            color: "text.secondary",
            fontWeight: 700,
            letterSpacing: "1px",
          }}
        >
          {statuses[statusIndex]}
        </Typography>
      </Box>

      {/* ===== FOOTER ===== */}
      <Box
        sx={{
          position: "absolute",
          bottom: 24,
          right: 24,
          opacity: 0.3,
          fontFamily: "monospace",
          fontSize: 9,
          lineHeight: 1.6,
          textAlign: "right",
        }}
      >
        PROTOCOL: RBAC_V2
        <br />
        ENCRYPTION: AES_256
        <br />
        GATEWAY: AUTH_CORE
      </Box>
    </Box>
  );
};

export default RoleLoader;
